jQuery(document).ready(function($){

  // $(document).on('change.zf.tabs', function(e) {
  //   var activeTab =  $($(e.target).find('.is-active a').attr('href'));
  //   activeTab.css('display', 'none').fadeIn();
  //   portfolioTabs.setIndicator(null, true);
  // });

  $('.portfolio-slider').slick({
    prevArrow: '<div class="portfolio-nav prev circle"><i class="white fal fa-angle-left"></i></div>',
    nextArrow: '<div class="portfolio-nav next circle"><i class="white fal fa-angle-right"></i></div>'
  });

  $('.portfolio-item').on('click', function() {
    var reveal = '#' + $(this).data('open');
    var index = $(this).data('index');
    var slider = $(reveal).find('.portfolio-slider');
    $(slider).slick('slickGoTo', index);
  })

  var portfolioTabs = {
    construct: function() {
      this.setIndicator();
      this.dropdown.on('click', this.toggleList.bind(this))
      $(document).on('change.zf.tabs', this.handleChange.bind(this));
    },

    indicator: $('#our-work-indicator'),

    list: $('#our-work-tabs'),

    dropdown: $('#our-work-dropdown'),

    listIsDown: false,

    setIndicator: function() {
      let text = $(this.list.find('.is-active')).text();
      this.indicator.text(text);
    },

    toggleList: function(event, up) {
      console.log('toggle');
      if (this.listIsDown || up) {
        this.list.slideUp();
        this.listIsDown = false;
      } else {
        this.list.slideDown();
        this.listIsDown = true;
      }
    },

    handleChange: function(e) {
      var activeTab =  $($(e.target).find('.is-active a').attr('href'));
      activeTab.css('display', 'none').fadeIn();
      this.setIndicator();
      if (window.innerWidth < 768) {
        this.toggleList(null, true);
      }
    }

  }

  if ($('#our-work-tabs').exists()) {
    console.log('test');
    portfolioTabs.construct();
  }


})
